import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { MyAuthContext } from "../../Context/AuthContext";
import { getTncConsent } from "../../services/login/loginApiService";
import LoginService, {
  getUserID,
  isLoggedIn,
} from "../../services/login/loginService";
import LoginRoutes from "./Login/LoginRoutes";
import ScrollToTop from "../ScrollToTop";
import VendorRoutes from "./VendorRoutes/VendorRoutes";
import CommonRoutes from "./CommonRoutes/CommonRoutes";
import ClientRoutes from "./ClientRoutes/ClientRoutes";
import { getTolocalStorage } from "../Constants/commenFeatures";
import { accRedircet } from "../../services/genralServise";
import { config } from "../../config/domain";
import { RoutesUrl } from "./constents";
import RouteAnnouncer from "../../utils/routeAnnouncer";

const Routes = () => {
  const isAuthFunction = (isAuthVal, tncVal) => {
    setCheckAuth({
      ...checkAuth,
      isAuth: isAuthVal,
      tncAccepted: tncVal,
    });
  };

  const [checkAuth, setCheckAuth] = useState({
    isAuth: false,
    tncAccepted: false,
    isAuthFunction: isAuthFunction,
  });

  const getTncDataRes = (res) => {
    if (res && res.data) {
      if (res.data.loginConsents) {
        let checkAPIConsent = res.data.loginConsents.filter((consn) => {
          return consn.name === "APIConsent";
        });
        if (checkAPIConsent.length > 0) {
          localStorage.setItem("tncAccepted", "false");
          isAuthFunction(true, false);
        } else {
          localStorage.setItem("tncAccepted", "true");
          isAuthFunction(true, true);
        }
      }
    }
  };

  // const logout = () => {
  //   let loginAs = getTolocalStorage("loginAs");
  //   if (loginAs === "vendor") {
  //     LoginService.vendorLogout();
  //   } else {
  //     LoginService.logout();
  //   }
  //   setCheckAuth({
  //     ...checkAuth,
  //     isAuth: false,
  //     tncAccepted: false,
  //   });
  //   accRedircet(config.root + RoutesUrl.Home);
  // };

  const getTncData = (userId) => {
    getTncConsent(getTncDataRes, userId);
  };

  useEffect(() => {
    let isClient = isLoggedIn();
    let isVendor = getTolocalStorage("access_token");
    if (isClient) {
      let tncFromLs = getTolocalStorage("tncAccepted");
      if (tncFromLs === undefined || tncFromLs === null) {
        let userId = getUserID();
        getTncData(userId);
      } else if (!tncFromLs) {
        isAuthFunction(true, false);
      } else {
        isAuthFunction(true, true);
      }
    } else if (isVendor) {
      isAuthFunction(true, true);
    } else {
      isAuthFunction(false, false);
    }
  }, []);

  return (
    <div>
      <MyAuthContext.Provider value={checkAuth}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <ScrollToTop />
          <RouteAnnouncer />
          <main id="main-content">
            <CommonRoutes />
            <LoginRoutes />
            <ClientRoutes />
            <VendorRoutes />
          </main>
        </BrowserRouter>
      </MyAuthContext.Provider>
    </div>
  );
};

export default Routes;
